import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Form, Input, Button, Message } from '@arco-design/web-react'
import { sendPasswordResetEmailApi } from '@/api/user'

export default function PasswordReset() {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const handleSubmit = async (values: { email: string }) => {
    setLoading(true)
    try {
      await sendPasswordResetEmailApi(values.email)
      setSent(true)
      Message.success(t('auth.resetLinkSent'))
    } catch (err: unknown) {
      Message.error(err instanceof Error ? err.message : t('auth.sendFailed'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--landing-bg)]">
      <div className="w-full max-w-[440px]">
        <div className="landing-auth-glass rounded-2xl p-8">
          <h1 className="text-xl font-semibold mb-4">{t('auth.resetTitle')}</h1>
          {sent ? (
            <div className="text-sm text-gray-600 py-6">
              {t('auth.resetEmailSentAlt')}
            </div>
          ) : (
            <Form onSubmit={handleSubmit} layout="vertical">
              <Form.Item field="email" label={t('auth.email')} rules={[{ required: true, type: 'email', message: t('auth.requiredEmailSimple') }]}>
                <Input placeholder={t('auth.placeholderEmailRegister')} size="large" />
              </Form.Item>
              <Button type="primary" htmlType="submit" size="large" loading={loading} long>
                {t('auth.sendResetLink')}
              </Button>
            </Form>
          )}
          <div className="mt-6 text-sm">
            <Link to="/?auth=login" className="text-[var(--brand-primary)]">{t('auth.backToLogin')}</Link>
          </div>
        </div>
      </div>
    </div>
  )
}
